/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Filter,
  HTTPValidationError,
  PortfolioInferredPositions,
  PositionPage,
  UniverseExcludedPosition,
} from '../models/index';
import {
    FilterFromJSON,
    FilterToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    PortfolioInferredPositionsFromJSON,
    PortfolioInferredPositionsToJSON,
    PositionPageFromJSON,
    PositionPageToJSON,
    UniverseExcludedPositionFromJSON,
    UniverseExcludedPositionToJSON,
} from '../models/index';

export interface GetInferredPositionsRequest {
    requestBody: Array<string>;
}

export interface GetPreTradePositionRequest {
    pageIndex?: number;
    pageSize?: number;
    sortLabel?: string;
    sortDesc?: boolean;
    filter?: Array<Filter>;
}

export interface GetReportPositionRequest {
    pageIndex?: number;
    pageSize?: number;
    sortLabel?: string;
    sortDesc?: boolean;
    filter?: Array<Filter>;
}

export interface GetUniverseExcludedPositionsRequest {
    requestBody: Array<string>;
}

/**
 * 
 */
export class PositionApi extends runtime.BaseAPI {

    /**
     * Retrieve inferred positions (T-1) for accounts with weights. Excluded positions are returned separately.
     */
    async getInferredPositionsRaw(requestParameters: GetInferredPositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PortfolioInferredPositions>>> {
        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling getInferredPositions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/inferred-positions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PortfolioInferredPositionsFromJSON));
    }

    /**
     * Retrieve inferred positions (T-1) for accounts with weights. Excluded positions are returned separately.
     */
    async getInferredPositions(requestParameters: GetInferredPositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PortfolioInferredPositions>> {
        const response = await this.getInferredPositionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve (cached) pre-trade positions with the specified filters.
     */
    async getPreTradePositionRaw(requestParameters: GetPreTradePositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PositionPage>> {
        const queryParameters: any = {};

        if (requestParameters.pageIndex !== undefined) {
            queryParameters['page_index'] = requestParameters.pageIndex;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.sortLabel !== undefined) {
            queryParameters['sort_label'] = requestParameters.sortLabel;
        }

        if (requestParameters.sortDesc !== undefined) {
            queryParameters['sort_desc'] = requestParameters.sortDesc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/pre-trade-position`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.filter?.map(FilterToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PositionPageFromJSON(jsonValue));
    }

    /**
     * Retrieve (cached) pre-trade positions with the specified filters.
     */
    async getPreTradePosition(requestParameters: GetPreTradePositionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PositionPage> {
        const response = await this.getPreTradePositionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve cached positions from the Data Warehouse (T-1 data) with the specified filters.
     */
    async getReportPositionRaw(requestParameters: GetReportPositionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PositionPage>> {
        const queryParameters: any = {};

        if (requestParameters.pageIndex !== undefined) {
            queryParameters['page_index'] = requestParameters.pageIndex;
        }

        if (requestParameters.pageSize !== undefined) {
            queryParameters['page_size'] = requestParameters.pageSize;
        }

        if (requestParameters.sortLabel !== undefined) {
            queryParameters['sort_label'] = requestParameters.sortLabel;
        }

        if (requestParameters.sortDesc !== undefined) {
            queryParameters['sort_desc'] = requestParameters.sortDesc;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/report-position`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.filter?.map(FilterToJSON),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PositionPageFromJSON(jsonValue));
    }

    /**
     * Retrieve cached positions from the Data Warehouse (T-1 data) with the specified filters.
     */
    async getReportPosition(requestParameters: GetReportPositionRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PositionPage> {
        const response = await this.getReportPositionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The first rule of the allocation type waterfall: positions excluded by an EXCLUDED conviction only are not included. Broker account ids should be concatenation of broker id and a_c (using _), e.g SCHWAB_12345678
     * Retrieve the positions of the broker accounts excluded from the trading universe by their asset class / type.
     */
    async getUniverseExcludedPositionsRaw(requestParameters: GetUniverseExcludedPositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UniverseExcludedPosition>>> {
        if (requestParameters.requestBody === null || requestParameters.requestBody === undefined) {
            throw new runtime.RequiredError('requestBody','Required parameter requestParameters.requestBody was null or undefined when calling getUniverseExcludedPositions.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/universe-excluded-positions`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.requestBody,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UniverseExcludedPositionFromJSON));
    }

    /**
     * The first rule of the allocation type waterfall: positions excluded by an EXCLUDED conviction only are not included. Broker account ids should be concatenation of broker id and a_c (using _), e.g SCHWAB_12345678
     * Retrieve the positions of the broker accounts excluded from the trading universe by their asset class / type.
     */
    async getUniverseExcludedPositions(requestParameters: GetUniverseExcludedPositionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UniverseExcludedPosition>> {
        const response = await this.getUniverseExcludedPositionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
